import Head from "next/head";
import { useRouter } from "next/router";

type TProps = {
  /**
   * @deprecated currentURL replaced by internal canonical variable
   */
  currentURL?: string;
  description?: string;
  title: string;
  siteTitle?: string;
  previewImage?: string;
  previewImageSquare?: string;
  microdata?: Record<string, string | number> | null;
};

export default function SEO({
  description = "Movi es el sitio web más fácil y seguro para comprar y vender autos usados en Costa Rica🇨. Publicá tu auto de forma gratuita y empezá a recibir ofertas.",
  title = "Los mejores autos usados en Costa Rica",
  siteTitle = "Movi Autos",
  previewImage = "https://res.cloudinary.com/movi-prod/image/upload/v1678198413/SEO/ogImage_hoaepd.png",
  previewImageSquare,
  microdata,
}: TProps) {
  const router = useRouter();
  const canonical = `https://www.moviautos.com${router.asPath.split("?")[0]}`;
  return (
    <Head>
      <link rel="canonical" href={canonical} />
      <title>{`${title} | ${siteTitle}`}</title>
      <meta name="description" content={description} />
      {/* <meta property="twitter:creator" content="@SundialCalendar" /> */}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} key="ogurl" />
      <meta property="og:site_name" content={siteTitle} key="ogsitename" />
      <meta property="og:title" content={title} key="ogtitle" />
      <meta property="og:description" content={description} key="ogdesc" />

      {/* Default og:image for FB and other social media */}
      <meta property="og:image" content={previewImage} key="ogimage" />
      <meta property="og:image:width" content="1200" key="ogimage-w" />
      <meta property="og:image:height" content="630" key="ogimage-h" />

      {/* Square og:image for Whatsapp */}
      <meta property="og:image" content={previewImageSquare} key="ogimage-sq" />
      <meta property="og:image:width" content="400" key="ogimage-sq-w" />
      <meta property="og:image:height" content="400" key="ogimage-sq-h" />

      {/* FB */}
      <meta
        property="fb:app_id"
        content={process.env.NEXT_PUBLIC_FACEBOOK_APP_ID}
      />

      {/* Twitter */}

      <meta name="twitter:card" content="summary_large_image" key="twcard" />
      <meta name="twitter:creator" content="Movi Autos" />
      <meta name="twitter:title" content={title} key="twtitle" />
      <meta
        name="twitter:description"
        content={description}
        key="twdescription"
      />
      <meta name="twitter:image" content={previewImage} key="twimage" />
      {/* <meta name="twitter:creator" content="SundialCalendar" key="twhandle" /> */}

      {microdata && Object.keys(microdata)?.length
        ? Object.keys(microdata).map((k) => (
            <meta
              key={k}
              property={k}
              content={microdata[k].toLocaleString()}
            />
          ))
        : null}
    </Head>
  );
}
